import { Typography } from "@mui/material";
import { Stack } from "@mui/system";

type WasteValueDisplayProps = {
  label: string;
  value: number | string;
  unit?: string;
};

export function WasteValueDisplay(props: WasteValueDisplayProps) {
  let value = props.value;
  if (isNumber(props.value)) {
    value = Math.round(props.value).toLocaleString();
  }
  const unit = props.unit ?? "lbs";
  return (
    <Stack py={1} justifyContent="end">
      <Typography fontSize="0.75rem" fontWeight={400} color="textSecondary">
        {props.label}
      </Typography>
      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Typography fontSize="2rem" fontWeight={400} color="textPrimary">
          {value}
        </Typography>
        {isNumber(props.value) && (
          <Typography fontSize="0.75rem" fontWeight={400} color="textSecondary">
            {unit}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

function isNumber(n: string | number): n is number {
  return typeof n === "number";
}
